<template>
 <div class="your-numbers">
     <h2 class="your-numbers-header">Your numbers</h2>
     
     <div class="selected-numbers">
        <div class="number-container" v-for="cart in $store.getters.numbersCart" :key="cart.number"> 
            <span class="selected-number">{{ cart.number }}</span>
            <button class="number-delete" v-on:click="removeNumber(cart.number)"></button>       
        </div>
     </div>
 </div>
</template>
<script>
import NumberService from "@/services/NumberService.js";

export default {
    methods: {       
        removeNumber(number) {
            const cart = this.$store.getters.numbersCart;

            if (cart.filter(item => item.number === number)) {
                NumberService.unReserveNumber(number, this.$store.getters.receipt)
                .then((result) => {
                    this.$store.commit('removeFromCart', number);
                    NumberService.getBasket(this.$store.getters.receipt)
                    .then((result) => {
                        this.$store.commit('refreshCart', result.data);

                        const cart = this.$store.getters.numbersCart;

                        if(cart.length < 1){
                            if(this.$store.getters.numbersCart.length < 1){
                                const numberType = this.$store.getters.numberType;
                                if(!this.$route.name) {
                                    this.$router.push({
                                        name: "NumberSelector",
                                        params: { routeNumberType: numberType },
                                    });
                                }
                            }
                        }
                    })
                });
            }
        },
    }
}
</script>